import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-edit-book-expense',
  templateUrl: './edit-book-expense.component.html'
})
export class EditBookExpenseComponent {

  item: any = {};

  constructor(
    public service: DigisubservicesService,
    public dialogRef: MatDialogRef<EditBookExpenseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // copy incoming data
    this.item = { ...data };
  }

  saveData() {

    const payload = {
      book_name: this.item.book_name,
      bookyear: this.item.bookyear,
      paper_bill: this.item.paper_bill || 0,
      printing_bill: this.item.printing_bill || 0,
      processing: this.item.processing || 0,
      cover: this.item.cover || 0,
      other: this.item.other || 0,
      e_shipping_charges: this.item.e_shipping_charges || 0
    };

    this.service.saveBookExpense(payload).subscribe((res: any) => {

      if (res.status === "success") {

        alert("Updated Successfully");

        // return updated row to parent
        this.dialogRef.close(this.item);

      } else {
        alert("Update Failed");
      }

    });
  }

  close() {
    this.dialogRef.close();
  }

}